import { render, staticRenderFns } from "./goodProductList.vue?vue&type=template&id=417b5cb6&scoped=true"
import script from "./goodProductList.vue?vue&type=script&lang=js"
export * from "./goodProductList.vue?vue&type=script&lang=js"
import style0 from "./goodProductList.vue?vue&type=style&index=0&id=417b5cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417b5cb6",
  null
  
)

export default component.exports